// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddNewDesignPackageSlotModalQueryVariables = Types.Exact<{
  dpId: Types.Scalars['ID']['input'];
}>;


export type AddNewDesignPackageSlotModalQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, location: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation }, planPackages: Array<{ __typename?: 'PlanPackage', id: string, name: string }> } };

export type AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables = Types.Exact<{
  filter: Types.MaterialAttributeDimensionFilter;
}>;


export type AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery = { __typename?: 'Query', materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> };

export type AddNewDesignPackageSlotModal_CreateSlotMutationVariables = Types.Exact<{
  input: Types.CreateDesignPackagePlaceholderTliInput;
}>;


export type AddNewDesignPackageSlotModal_CreateSlotMutation = { __typename?: 'Mutation', createDesignPackagePlaceholderTli: { __typename?: 'CreateDesignPackagePlaceholderTliResult', placeholderTli: { __typename?: 'TakeoffLineItem', id: string, slot: { __typename?: 'ItemSlot', id: string } }, readyPlanAggregateVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string }, planPackageIncomingSlots: Array<{ __typename?: 'PlanPackageIncomingSlot', id: string }> } };


export const AddNewDesignPackageSlotModalDocument = gql`
    query AddNewDesignPackageSlotModal($dpId: ID!) {
  designPackage(id: $dpId) {
    id
    location {
      code
    }
    planPackages {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useAddNewDesignPackageSlotModalQuery__
 *
 * To run a query within a React component, call `useAddNewDesignPackageSlotModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddNewDesignPackageSlotModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddNewDesignPackageSlotModalQuery({
 *   variables: {
 *      dpId: // value for 'dpId'
 *   },
 * });
 */
export function useAddNewDesignPackageSlotModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddNewDesignPackageSlotModalQuery, AddNewDesignPackageSlotModalQueryVariables> & ({ variables: AddNewDesignPackageSlotModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddNewDesignPackageSlotModalQuery, AddNewDesignPackageSlotModalQueryVariables>(AddNewDesignPackageSlotModalDocument, options);
      }
export function useAddNewDesignPackageSlotModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddNewDesignPackageSlotModalQuery, AddNewDesignPackageSlotModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddNewDesignPackageSlotModalQuery, AddNewDesignPackageSlotModalQueryVariables>(AddNewDesignPackageSlotModalDocument, options);
        }
// @ts-ignore
export function useAddNewDesignPackageSlotModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddNewDesignPackageSlotModalQuery, AddNewDesignPackageSlotModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddNewDesignPackageSlotModalQuery, AddNewDesignPackageSlotModalQueryVariables>;
export function useAddNewDesignPackageSlotModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddNewDesignPackageSlotModalQuery, AddNewDesignPackageSlotModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddNewDesignPackageSlotModalQuery | undefined, AddNewDesignPackageSlotModalQueryVariables>;
export function useAddNewDesignPackageSlotModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddNewDesignPackageSlotModalQuery, AddNewDesignPackageSlotModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddNewDesignPackageSlotModalQuery, AddNewDesignPackageSlotModalQueryVariables>(AddNewDesignPackageSlotModalDocument, options);
        }
export type AddNewDesignPackageSlotModalQueryHookResult = ReturnType<typeof useAddNewDesignPackageSlotModalQuery>;
export type AddNewDesignPackageSlotModalLazyQueryHookResult = ReturnType<typeof useAddNewDesignPackageSlotModalLazyQuery>;
export type AddNewDesignPackageSlotModalSuspenseQueryHookResult = ReturnType<typeof useAddNewDesignPackageSlotModalSuspenseQuery>;
export type AddNewDesignPackageSlotModalQueryResult = ApolloReactCommon.QueryResult<AddNewDesignPackageSlotModalQuery, AddNewDesignPackageSlotModalQueryVariables>;
export const AddNewDesignPackageSlotModal_MaterialAttributeDimensionsDocument = gql`
    query AddNewDesignPackageSlotModal_MaterialAttributeDimensions($filter: MaterialAttributeDimensionFilter!) {
  materialAttributeDimensions(filter: $filter) {
    id
    name
    values {
      id
      textValue
    }
  }
}
    `;

/**
 * __useAddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery__
 *
 * To run a query within a React component, call `useAddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery, AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables> & ({ variables: AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery, AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables>(AddNewDesignPackageSlotModal_MaterialAttributeDimensionsDocument, options);
      }
export function useAddNewDesignPackageSlotModal_MaterialAttributeDimensionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery, AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery, AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables>(AddNewDesignPackageSlotModal_MaterialAttributeDimensionsDocument, options);
        }
// @ts-ignore
export function useAddNewDesignPackageSlotModal_MaterialAttributeDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery, AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery, AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables>;
export function useAddNewDesignPackageSlotModal_MaterialAttributeDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery, AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery | undefined, AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables>;
export function useAddNewDesignPackageSlotModal_MaterialAttributeDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery, AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery, AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables>(AddNewDesignPackageSlotModal_MaterialAttributeDimensionsDocument, options);
        }
export type AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryHookResult = ReturnType<typeof useAddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery>;
export type AddNewDesignPackageSlotModal_MaterialAttributeDimensionsLazyQueryHookResult = ReturnType<typeof useAddNewDesignPackageSlotModal_MaterialAttributeDimensionsLazyQuery>;
export type AddNewDesignPackageSlotModal_MaterialAttributeDimensionsSuspenseQueryHookResult = ReturnType<typeof useAddNewDesignPackageSlotModal_MaterialAttributeDimensionsSuspenseQuery>;
export type AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryResult = ApolloReactCommon.QueryResult<AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQuery, AddNewDesignPackageSlotModal_MaterialAttributeDimensionsQueryVariables>;
export const AddNewDesignPackageSlotModal_CreateSlotDocument = gql`
    mutation AddNewDesignPackageSlotModal_CreateSlot($input: CreateDesignPackagePlaceholderTliInput!) {
  createDesignPackagePlaceholderTli(input: $input) {
    placeholderTli {
      id
      slot {
        id
      }
    }
    readyPlanAggregateVersion {
      id
    }
    planPackageIncomingSlots {
      id
    }
  }
}
    `;

/**
 * __useAddNewDesignPackageSlotModal_CreateSlotMutation__
 *
 * To run a mutation, you first call `useAddNewDesignPackageSlotModal_CreateSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewDesignPackageSlotModal_CreateSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewDesignPackageSlotModalCreateSlotMutation, { data, loading, error }] = useAddNewDesignPackageSlotModal_CreateSlotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNewDesignPackageSlotModal_CreateSlotMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddNewDesignPackageSlotModal_CreateSlotMutation, AddNewDesignPackageSlotModal_CreateSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddNewDesignPackageSlotModal_CreateSlotMutation, AddNewDesignPackageSlotModal_CreateSlotMutationVariables>(AddNewDesignPackageSlotModal_CreateSlotDocument, options);
      }
export type AddNewDesignPackageSlotModal_CreateSlotMutationHookResult = ReturnType<typeof useAddNewDesignPackageSlotModal_CreateSlotMutation>;
export type AddNewDesignPackageSlotModal_CreateSlotMutationResult = ApolloReactCommon.MutationResult<AddNewDesignPackageSlotModal_CreateSlotMutation>;